import {Component} from '@angular/core';
import {LinkService} from "@cbcore/services/utils/links/links.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  standalone: true
})
export class FooterComponent {

  constructor(private _linkService: LinkService) {
  }

  openLink() {
    this._linkService.openLink('https://www.colossusfantasy.com/help/20-patent-information/?utm_source=MidoApp&utm_medium=Footer&utm_campaign=Terms');
  }
}
